import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

/**
 * AlertPopup Component
 */
class AlertPopup extends React.Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };
  }

  /**
   * setModal
   * @param val
   */
  setModal = (val) => {
    this.setState({ modal: !val });
    this.props.toggleAlert();
  };

  /**
   * toggle function
   */
  toggle = () => this.setModal(this.state.modal);

  /**
   * Render function
   * @returns {Modal}
   */
  render() {
    const { content } = this.props;
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalBody>{content ? content : 'Something went wrong'}</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              Ok
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

/**
 * defaultProps
 * @type {{content: string}}
 */
AlertPopup.defaultProps = {
  content: ''
};

/**
 * AlertPopup
 */
export default AlertPopup;
